import React from 'react';

import { bizminderColors } from '../../utils/globals';
import CustomerDashboardCard from '../../components/CustomerDashboardCard';
import CDProgressDetailsCard from '../../components/CDProgressDetailsCard';
import LacWhite from '../../images/LAC_white.png';
import PaWhite from '../../images/PA_white.png';
import TaWhite from '../../images/TA_white.png';
import DacWhite from '../../images/DAC_white.png';
import CrmWhite from '../../images/CRM_white.png';
import LacBlack from '../../images/LAC_black.png';
import PaBlack from '../../images/PA_black.png';
import TaBlack from '../../images/TA_black.png';
import DacBlack from '../../images/DAC_black.png';
import CrmBlack from '../../images/CRM_black.png';

const CustomerDashboard = (props) => {
  return (
    <div className="container-fluid">
      <h2 style={{ marginTop: 10, textAlign: 'center' }}>Customer Name</h2>
      <div className="row">
        <div className="col">
          <CustomerDashboardCard bgColor={bizminderColors[0]} image={LacWhite} title="Lead & Conversion" percent={25} />
        </div>
        <div className="col">
          <CustomerDashboardCard bgColor={bizminderColors[1]} image={PaWhite} title="Preliminary Analysis" percent={5} />
        </div>
        <div className="col">
          <CustomerDashboardCard bgColor={bizminderColors[2]} image={TaWhite} title="Technical Analysis" percent={0} />
        </div>
        <div className="col">
          <CustomerDashboardCard bgColor={bizminderColors[3]} image={DacWhite} title="Disbursement & Compliance" percent={0} />
        </div>
        <div className="col">
          <CustomerDashboardCard bgColor={bizminderColors[4]} image={CrmWhite} title="Customer Relations" percent={25} />
        </div>
      </div>
      <CDProgressDetailsCard
        color={bizminderColors[0]}
        pbBgColor="e5f4fa"
        image={LacBlack}
        title="Lead & Conversion"
        modules={['Lead Data', 'Further Information', 'Lead Approval', 'Negotiation & Conclusion', 'Mandate & Agreement']}
        progress={[100, 50, 0, 0, 0]}
      />
      <CDProgressDetailsCard
        color={bizminderColors[1]}
        pbBgColor="#eef9fa"
        image={PaBlack}
        title="Preliminary Analysis"
        modules={['Factsheet', 'Bank Submission', 'Discussion & Monitoring']}
        progress={[40, 0, 0]}
      />
      <CDProgressDetailsCard
        color={bizminderColors[2]}
        pbBgColor="#fbeae9"
        image={TaBlack}
        title="Technical Analysis"
        modules={[
          'Financial',
          'Credit Risk',
          'Business',
          'Project',
          'Security',
          'Process Note',
          'Title Search',
          'Engineers Valuation',
          'TEV Study',
          'Due Diligence',
          'External Rating',
          'Bank Submission',
          'Query Support',
          'Negotiation & Approval',
        ]}
        progress={[
          40,
          30,
          10,
          0,
          0,
          0,
          80,
          20,
          0,
          0,
          0,
          0,
          0,
          10,
        ]}
      />
      <CDProgressDetailsCard
        color={bizminderColors[3]}
        pbBgColor="#fef2ec"
        image={DacBlack}
        title="Disbursement & Compliance"
        modules={['Pre-disbursement Conditions', 'Pre-disbursement Compliance', 'Post-disbursement Conditions', 'Post-disbursement Compliance']}
        progress={[40, 0, 0, 0]}
      />
      <CDProgressDetailsCard
        color={bizminderColors[4]}
        pbBgColor="#edf5f1"
        image={CrmBlack}
        title="Customer Relations"
        modules={['Module 1', 'Module 2']}
        progress={[0, 0]}
      />
    </div>
  );
};

CustomerDashboard.propTypes = {
};

export default CustomerDashboard;



// WEBPACK FOOTER //
// ./src/pages/customer/CustomerDashboard.jsx